<ng-container *ngIf="isLoading">

    <div class="d-flex justify-content-center align-items-center h-100">

        <img src="../../../assets/Img/loading_safar.gif" alt="loading">

    </div>

</ng-container>

<ng-container *ngIf="!isManageTrip">

    <div class="headerPart d-flex justify-content-center align-items-center bg-white p-2 mb-1 fw-bold">

        <span>کارتابل درخواست های سفر</span>
    
    </div>
    
    <div class="section">
    
        <table class="table table-striped bg-white mt-1 dirI" id="excel-car-list">
    
            <thead>
    
                <tr class="text-center">
    
                    <th scope="col"># </th>
    
                    <th scope="col">عملیات</th>
    
                    <th scope="col">کد سفر </th>
    
                    <th scope="col">نام متقاضی</th>
    
                    <th scope="col">جایگاه سازمانی متقاضی</th>
    
                    <th scope="col">تاریخ سفر</th>
    
                    <th scope="col">ساعت سفر</th>
    
                    <th scope="col">نوع سفر</th>
    
                    <th scope="col">دلیل سفر</th>
    
                    <th scope="col">اهمیت سفر</th>
    
                    <th scope="col">آدرس مقصد</th>
    
                </tr>
    
            </thead>
    
            <tbody>
    
                <tr class="f14 text-center" *ngFor="let item of trips;let i=index">
    
                    <th class="text-dark">{{i+1 | faNum}}</th>
    
                    <th class="d-flex gap-2 pb-3">
    
                        <i class="fa fa-info-circle fa-lg text-primary" (click)="showDetailsModal(item)"></i>
    
                        <i (click)="confirmTripModal(item)" class="fa fa-hand-paper-o fa-lg text-success"></i>
    
                        <i (click)="newMapShowTripSourceAndDest(item)" class="fa fa-map-pin fa-lg text-primary"></i>
    
                        <i class="fa fa-edit fa-lg text-secondary" (click)="showDetailsModal(item,true)"></i>
    
                    </th>
    
                    <th class="text-dark">{{item.iOfficialTrip|faNum}}</th>
    
                    <th class="text-dark">{{item.strApplicantName}} {{item.strApplicantFamily}}</th>
    
                    <th class="text-dark">{{item.strUserManager_Chart_strComment}}</th>
    
                    <th class="text-dark">{{item.strTripDate | faNum}}</th>
    
                    <th class="text-dark">{{item.strTripTime | faNum}}</th>
    
                    <th class="text-dark">{{item.bMission? 'مأموریتی': item.bExclusive? 'در اختیار': item.bHaveReturn? 'دوطرفه': 'یک طرفه'}}</th>
    
                    <th class="text-dark">{{item.strTripReason_strComment}}</th>
    
                    <th class="text-dark">{{item.strTripImportance_strComment}}</th>
    
                    <th class="text-dark">{{item.strDestinationAddress}}</th>
    
                </tr>
    
            </tbody>
    
        </table>
    
    </div>

</ng-container>

<!-- Confirm or reject Modal -->

<div class="modal fade" id="confirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content dirI">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">تایید سفر</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                آیا سفر مورد نظر را تأیید میکنید؟
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="setTripConfirmation('confirmModal')">تأیید
                    سفر</button>
                <button type="button" class="btn btn-danger" (click)="setTripRejection('confirmModal')">لغو سفر</button>
            </div>
        </div>
    </div>
</div>

<!-- Map modal -->

<div class="modal fade" id="maplat" tabindex="-1" aria-labelledby="" data-bs-keyboard="false" data-bs-backdrop='static'>
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content p-1">
            <div class="modal-header dirI" style="height: 20px;">
                <h5 class="modal-title">مبدأ و مقصد</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div id="map" class="position-sticky w-100 " style="height: 650px;">
                <div [formGroup]="path"
                    class="d-flex justify-content-around flex-wrap position-absolute dirI bg-th-yellow w-100 p-1 border-bottom border-info"
                    style="z-index: 1000; margin-bottom: 10px;">
                    <div class="mx-1">
                        <span>مسافت تقریبی: <strong>{{path.controls['distance'].value}}</strong> کیلومتر</span>
                    </div>
                    <div class="mx-1">
                        <span>زمان تقریبی سفر: <strong>{{path.controls['duration'].value}}</strong> دقیقه</span>
                    </div>
                </div>
                <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- مشاهده اطلاعات سفر و مدال ویرایش سفر -->

<!-- ویرایش سفر توسط صفحه مدیریت سفرها -->

<div class="modal fade" id="DetailModal" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop='static'>
    
    <div class="modal-dialog modal-xl">
        
        <div class="modal-content dirI">
            
            <div class="modal-header">
                
                <h5 class="modal-title" id="exampleModalLabel">اطلاعات سفر</h5>
                
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="isManageTrip ? closeEditTrip() : '' "></button>
                
            </div>

            <div class="modal-body">

                <div [formGroup]="mdlTripEdit" class="container-fluid row gx-2 gy-2 p-2" >

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> کد رهگیری</label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.iOfficialTrip | faNum" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> نام و نام خانوادگی </label>

                        <input class="form-control text-center p-2" [value]="currentRecord?.strApplicantName + ' '+ currentRecord?.strApplicantFamily" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> شماره موبایل </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.strApplicantMobile | faNum " disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> دلیل سفر </label>

                        <ng-container *ngIf="!bEditMode; else tripReason">

                            <input class="form-control text-center p-2" [value]="currentRecord?.strTripReason_strComment" disabled>

                        </ng-container>

                        <ng-template #tripReason>

                            <select formControlName="tiTripReason" class="form-select text-center p-2" style="background-color:#fefce8!important;">

                                <option *ngFor="let item of tripReasons" value="{{item.tiTripReason}}">
    
                                    {{item.strComment}}
    
                                </option>
    
                            </select>

                        </ng-template>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> کاربری متحرک </label>

                        <ng-container *ngIf="!bEditMode; else mobileType">

                            <input class="form-control text-center p-2" [value]="currentRecord?.strTripMobileType_strComment" disabled>

                        </ng-container>

                        <ng-template #mobileType>

                            <select formControlName="tiMobileType" class="form-select text-center p-2" style="background-color:#fefce8!important;">

                                <option *ngFor="let item of vehicleTypes" value="{{item.tiMobileType}}">
    
                                    {{item.strComment}}
                                
                                </option>
    
                            </select>

                        </ng-template>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> تاریخ درخواست </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.strRequestDate | faNum" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> اهمیت سفر </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.strTripImportance_strComment | faNum" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> جایگاه سازمانی </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.strUserManager_Chart_strComment | faNum" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> ساعت درخواست </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.strRequestTime.trim() | faNum" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> نوع سفر </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.bMission? 'مأموریتی': currentRecord?.bExclusive? 'در اختیار': currentRecord?.bHaveReturn? 'دو طرفه': 'یک طرفه'" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> تاریخ سفر </label>

                        <ng-container *ngIf="!bEditMode; else tripDate">

                            <input class="form-control p-2 text-center" [value]="currentRecord?.strTripDate | faNum" disabled>

                        </ng-container>

                        <ng-template #tripDate>

                            <form [formGroup]="mdlTripEdit" style="margin-right: -2px; margin-left: 3px;">

                                <ng-persian-datepicker [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                                    [dateFormat]="'jYYYY/jMM/jDD'">
    
                                    <input type="text" formControlName="strTripDate" style="background-color:#fefce8!important;"
                                    
                                        class="form-control text-center p-2  pointer" readonly />
    
                                </ng-persian-datepicker>
    
                            </form>

                        </ng-template>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> ساعت سفر </label>

                        <ng-container *ngIf="!bEditMode; else tripTime">

                            <input class="form-control text-center p-2" [value]="currentRecord?.strTripTime.trim() | faNum" disabled>

                        </ng-container>

                        <ng-template #tripTime>

                            <div class="input-group clockpicker pointer">

                                <input style="background-color:#fefce8!important;" class="form-control text-center p-2" value="23:59" id="Ttime" readonly>
    
                                <span class="input-group-addon">
    
                                    <span class="glyphicon glyphicon-time"></span>
    
                                </span>
    
                            </div>

                        </ng-template>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> تعداد سفرهای امروز جایگاه سازمانی </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.tiAppUsage + ' مورد ' | faNum" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-3 p-2">

                        <label class="mb-2 text-muted"> حوزه خدمت متقاضی  </label>

                        <input class="form-control p-2 text-center" [value]="currentRecord?.strMobileDomain_strComment" disabled>

                    </div>

                    <div class="col-12 border border-1 my-2"></div>

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> همراهان </label>

                        <ng-container *ngIf="!bEditMode">

                            <input class="form-control text-center p-2" [value]="currentRecord?.strPassengersName" disabled>

                        </ng-container>

                        <ng-container *ngIf="bEditMode">

                            <input type="text" class="form-control p-2" style="background-color:#fefce8!important;"
                            
                                formControlName="strPassengersName" [value]="currentRecord?.strPassengersName">

                        </ng-container>


                    </div>

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> موبایل همراهان </label>

                        <input class="form-control p-2 text-end" 
                        
                            [value]="currentRecord?.strPassengersMobile | faNum" disabled>

                    </div>

                    <div class="position-relative col-12 col-md-6 p-2">

                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                            <input class="form-check-input m-0" type="checkbox" id="bCheckByQRCode" formControlName="bCheckByQRCode" [value]="currentRecord?.bCheckByQRCode">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bCheckByQRCode"> نیاز به اعتبارسنجی مسافر </label>
                        
                        </div>
                        

                    </div>

                    <div class="position-relative col-12  p-2">

                        <label class="mb-2 text-muted"> مبدأ </label>

                        <ng-container *ngIf="!bEditMode">

                            <input class="form-control  p-2" [value]="currentRecord?.strSourceAddress" disabled>

                        </ng-container>

                        <ng-container *ngIf="bEditMode">

                            <input type="text" class="form-control p-2" style="background-color:#fefce8!important;"

                                (keyup.enter)="getLocationGeocoding(0, 0, $event.target.value)"
                            
                                formControlName="strSourceAddress" [value]="currentRecord?.strSourceAddress">

                                <span class="position-absolute" style="top: 9px;left: 9px;border-radius: 3px;background-color:#fefce8!important;padding: 8px 12px!important;">

                                    <i class="fa fa-map-marker text-primary fa-lg pointer" (click)="newOpenMap(0)"></i>

                                </span>

                                <small *ngIf="this.path.controls['olatIn']?.value == 0 && this.path.controls['olatIn']?.value != ''"  
                                
                                    class="text-danger me-1">

                                    آدرس وارد شده صحیح نمی باشد
                                
                                </small>

                                <small *ngIf="this.path.controls['olatIn']?.value > 0 && this.path.controls['olatIn']?.value != '' && origin?.strAddress"  
                                    
                                    class="text-success fw-bold me-1"> 
                                    
                                    {{ origin?.strAddress }} 
                                
                                </small>

                        </ng-container>


                    </div>

                    <div class="position-relative col-12  p-2">

                        <label class="mb-2 text-muted"> مقصد </label>

                        <ng-container *ngIf="!bEditMode">

                            <input class="form-control p-2" [value]="currentRecord?.strDestinationAddress" disabled>

                        </ng-container>

                        <ng-container *ngIf="bEditMode">

                            <input type="text" class="form-control p-2" style="background-color:#fefce8!important;"

                                (keyup.enter)="getLocationGeocoding(0, 1, $event.target.value)"
                            
                                formControlName="strDestinationAddress" [value]="currentRecord?.strDestinationAddress">

                                <span class="position-absolute" style="top: 9px;left: 9px;border-radius: 3px;background-color:#fefce8!important;padding: 8px 12px!important;">

                                    <i class="fa fa-map-marker text-primary fa-lg pointer" (click)="newOpenMap(1)"></i>

                                </span>

                                <small *ngIf="this.path.controls['dlatIn']?.value == 0 && this.path.controls['dlatIn']?.value != ''" 
                                
                                    class="text-danger me-1">

                                    آدرس وارد شده صحیح نمی باشد

                                </small>

                                <small *ngIf="this.path.controls['dlatIn']?.value > 0 && this.path.controls['dlatIn']?.value != '' && destination?.strAddress" 
                                    
                                    class="text-success fw-bold me-1">

                                    {{ destination?.strAddress }}

                                </small>

                        </ng-container>

                    </div>

                    <div class="position-relative col-12  p-2">

                        <label class="mb-2 text-muted"> توضیحات </label>

                        <ng-container *ngIf="!bEditMode">

                            <input class="form-control text-center p-2" [value]="currentRecord?.strComment" disabled>

                        </ng-container>

                        <ng-container *ngIf="bEditMode">

                            <input type="text" formControlName="strComment"  style="background-color:#fefce8!important;"
                            
                                class="form-control p-2" [value]="currentRecord?.strComment">

                        </ng-container>

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <ng-container *ngIf="!bEditMode">

                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="newMapShowTripSourceAndDest(currentRecord)">مسیر سفر</button>

                    <button type="button" class="btn btn-success" (click)="setTripConfirmation('DetailModal')">تأیید سفر</button>
    
                    <button type="button" class="btn btn-danger" (click)="setTripRejection('DetailModal')">لغو سفر</button>
    
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن </button>

                </ng-container>

                <ng-container *ngIf="bEditMode">

                    <button type="button" class="btn btn-success" (click)="UpdateTrip()">به روزرسانی</button>
                    
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeEditTrip()">بستن </button>

                </ng-container>

            </div>

        </div>

    </div>

</div>

<!-- Map modal -->

<div class="modal fade" id="mapModal" tabindex="-1" aria-labelledby="" data-bs-keyboard="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI" style="height: 20px;">

                <h5 class="modal-title"> {{ mapHeader }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="showDetailsModal(currentRecord,true)"></button>

            </div>

            <div id="mapEdit" class="position-sticky w-100 " style="height: 650px;">

                <div [formGroup]="path" class="d-flex justify-content-around flex-wrap position-absolute dirI bg-th-yellow w-100 p-1 border-bottom border-info" style="z-index: 1000; margin-bottom: 10px;">

                    <div class="d-flex align-items-center px-2 py-2 col-11">

                        <label for="addressBar"> آدرس </label>

                        <input name="addressBar" formControlName="addressBar" 

                            class="rounded w-100 ms-2 p-1" style="border: none;" placeholder="آدرس خود را جستجو کنید ..."

                            (keyup.enter)="getLocationGeocoding(1, mapMode, $event.target.value)" type="text">
                            
                    </div>

                </div>

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button (click)="confirmMap()" data-bs-dismiss="modal" class="btn btn-success">
                    
                    تایید
                    
                    <i class="fa fa-check"></i>
                
                </button>

            </div>

        </div>

    </div>

</div>